<script setup>
import { ref } from 'vue';
import { __, requestSimActivation } from '@/utils';
import Modal from "@components/modal.vue";
import IconPhones from '@components/icons/icon-phones.vue';
import OtpCode from "@components/otp-code.vue";
import Loader from '@components/loader.vue';
import ResendOTP from '@components/ResendOTP.vue';

const loader = ref(false);
const otpCode = ref('');

const { values, setPhone, setResponse } = defineProps({
    showOTPPopup: Boolean,
    handleModalClose: Function,
    setResponse: Function,
    setPhone: Function,
    values: Object,
});

const emit = defineEmits(['error', 'response', 'phone']);

const validateOTP = async () => {
    loader.value = true;
    const response = await requestSimActivation({
        ...values,
        sms_validation: otpCode.value.toString()
    });
    loader.value = false;

    const responseObj = JSON.parse(response.data);

    if(response.success && responseObj?.response?.subscribers?.length) {
        setResponse({
            ...responseObj.response,
            sim_type: values.sim_type,
        }, true);
        setPhone(values.msisdn);
    } else {
        emit('error', true)
    }
}
</script>

<template>
    <Modal :isActive="showOTPPopup" @close="handleModalClose">
		<template #head>
			<h6>
				{{ __('Attention - your number is about to be blocked!') }}
			</h6>
		</template>

		<template #body>
			<div class="notice-verification">
				<div class="notice-verification__icon">
					<IconPhones />
				</div>
				<div class="notice__body">
					<p>
						{{ __('Porting a phone number allows you to switch from one mobile phone company to another without the need to change the phone number you are used to. The goal of the mobility process is to create competition in the market by moving easily and quickly between the cellular companies.') }}
					</p>
					<p>
						{{ __('In order to enable the roaming procedure, we must make sure that this number is indeed associated with you,') }}<br/>
                        <strong>{{ __('We will now send you a 4-digit verification code via SMS.') }}</strong><br />
						<strong>{{ __('The 4 sofas you received must be entered here') }}</strong>
					</p>
				</div><!-- /.notice__body -->

				<div class="notice__field">
					<div class="field-code">
						<div class="field__controls">
							<OtpCode @changed="otpCode = $event" />
						</div><!-- /.field__controls -->

						<ResendOTP 
                            :msisdn="values.msisdn"
                            :loader="loader"
                            @loader="loader = $event"
                        />
					</div><!-- /.field-code -->
				</div><!-- /.notice__field -->

				<div class="notice__actions">
					<button class="notice__btn btn" @click="validateOTP" :disabled="otpCode.length < 4 || loader" type="button">
						{{ __('Confirmation and activation') }} <Loader v-if="loader && showOTPPopup" />
					</button><!-- /.btn -->
				</div><!-- /.notice__actions -->
			</div><!-- /.notice-verification -->
		</template>
	</Modal>
</template>